import TagComponent from "../../../../components/buttons/tagComponent";
import { useGetEditor } from "../../../../context/useEditorContext";
import { useTheme } from "../../../../context/useThemeContext";
import useDataStore from "../../../../stores/dataStore";
import useMainStore from "../../../../stores/mainStore";
import useTextFilesStore from "../../../../stores/textFilesStore";
import { htmlToPlainText } from "../../../../utility/htmlToPlainText";
import NoteContextMenu from "../../../contextMenu/contextMenus/noteContextMenu";
import { Editor } from "@tiptap/react";
import TabContextMenu from "../../../contextMenu/contextMenus/tabContextMenu";

export function NoteContextMenuWrapper(props: {
    noteID: string;
    isTabContextMenu?: boolean;
    setIsRenaming: React.Dispatch<React.SetStateAction<boolean>>;
}) {
    const editor = useGetEditor().editor.current;

    if (props.isTabContextMenu) {
        return (
            <TabContextMenu
                id={props.noteID}
                copy={async () => {
                    copyNote(props.noteID);
                }}
                paste={() => {
                    pasteNote(props.noteID, editor);
                }}
                rename={() => {
                    // renameNode(props.noteID);
                    props.setIsRenaming(true);
                }}
                open={() => {
                    openNote(props.noteID);
                }}
                openFolder={() => {
                    openFolder(props.noteID);
                }}
                close={() => {
                    useMainStore.getState().remove.closeNote(props.noteID);
                }}
                duplicate={() => {
                    duplicateNote(props.noteID);
                }}
                changeFolder={() => {}}
                delete={() => {
                    deleteNote(props.noteID);
                }}
                shiftLeft={() => {
                    shiftLeft(props.noteID);
                }}
                shiftRight={() => {
                    shiftRight(props.noteID);
                }}
            />
        );
    } else {
        return (
            <NoteContextMenu
                id={props.noteID}
                copy={async () => {
                    copyNote(props.noteID);
                }}
                paste={() => {
                    pasteNote(props.noteID, editor);
                }}
                rename={() => {
                    // renameNode(props.noteID);
                    props.setIsRenaming(true);
                }}
                open={() => {
                    openNote(props.noteID);
                }}
                close={() => {
                    useMainStore.getState().remove.closeNote(props.noteID);
                }}
                duplicate={() => {
                    duplicateNote(props.noteID);
                }}
                changeFolder={() => {}}
                delete={() => {
                    deleteNote(props.noteID);
                }}
            />
        );
    }
}
export default NoteContextMenuWrapper;

async function copyNote(noteID: string) {
    const htmlContent = await useTextFilesStore
        .getState()
        .getTextFile(noteID)
        .then((html) => html?.content || "");

    if (navigator.clipboard.write) {
        const item = new ClipboardItem({
            "text/plain": new Blob([htmlToPlainText(htmlContent)], {
                type: "text/plain",
            }),
            "text/html": new Blob([htmlContent], {
                type: "text/html",
            }),
        });
        navigator.clipboard.write([item]);
    } else {
        // Fallback for older browsers
        navigator.clipboard.writeText(htmlToPlainText(htmlContent));
    }

    // Set software specific data
    useMainStore.getState().set.setTempHTML(() => htmlContent);
}

function pasteNote(noteID: string, editor: Editor | null) {
    if (!editor) return;

    if (!useMainStore.getState().temp?.copyHTML) return;

    // If note is open
    if (useMainStore.getState().data.selectedNoteID === noteID) {
        const htmlContent = useMainStore.getState().temp?.copyHTML || "";

        // Set editor text
        editor.commands.setContent(htmlContent || "", false);

        // Save
        useTextFilesStore.getState().saveContent(noteID, htmlContent);
        useDataStore.getState().set.note(noteID, {
            changesMade: false,
        });
    } else {
        useTextFilesStore
            .getState()
            .setTextFile(noteID, useMainStore.getState().temp?.copyHTML || "");
    }
}

function openNote(noteID: string) {
    useMainStore.getState().open.openNote(noteID);
}

function openFolder(noteID: string) {
    if (!noteID) return;

    const noteFolderID = useDataStore.getState().data.notes[noteID]?.folderID;

    if (noteFolderID) {
        useMainStore.getState().set.selectedFolderID(() => noteFolderID);
    } else {
        useMainStore.getState().set.selectedFolderID(() => "uncategorized");
    }
}

function deleteNote(noteID: string) {
    if (!noteID) return;

    useDataStore.getState().remove.note(noteID);
}

function duplicateNote(noteID: string) {
    if (!noteID) return;

    useDataStore.getState().add.duplicateNote(noteID, true);
}

function shiftLeft(noteID: string) {
    useMainStore.getState().set.openedNoteIDs((prev) => {
        const newOpenedNoteIDs = [...(prev || [])];
        const noteIndex = newOpenedNoteIDs.indexOf(noteID);
        if (noteIndex > 0) {
            newOpenedNoteIDs.splice(noteIndex, 1);
            newOpenedNoteIDs.splice(noteIndex - 1, 0, noteID);
        }

        return newOpenedNoteIDs;
    });
}

function shiftRight(noteID: string) {
    useMainStore.getState().set.openedNoteIDs((prev) => {
        const newOpenedNoteIDs = [...(prev || [])];
        const noteIndex = newOpenedNoteIDs.indexOf(noteID);
        if (noteIndex !== -1 && noteIndex < newOpenedNoteIDs.length - 1) {
            newOpenedNoteIDs.splice(noteIndex, 1);
            newOpenedNoteIDs.splice(noteIndex + 1, 0, noteID);
        }

        return newOpenedNoteIDs;
    });
}
